/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_3_Your_5Inputs */



/**
* | output |
* | --- |
* | "Compliance with all applicable regulatory requirements" |
*
* @param {Guardrails_Section_3_Your_5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_3_your_5 = /** @type {((inputs?: Guardrails_Section_3_Your_5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_3_Your_5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einhaltung aller für Sie geltenden regulatorischen Anforderungen")
	return /** @type {LocalizedString} */ ("Compliance with all applicable regulatory requirements")
});